import { useEffect } from 'react';

/**
 * usePageTitle — sets the browser tab title dynamically.
 * Usage: usePageTitle('Members');  → "Members | Fitxero"
 *        usePageTitle();           → "Fitxero | Smart Gym Management Software"
 */
const BRAND = 'Fitxero';

export function usePageTitle(page) {
  useEffect(() => {
    document.title = page ? `${page} | ${BRAND}` : `${BRAND} | Smart Gym Management Software`;
    return () => {
      document.title = `${BRAND} | Smart Gym Management Software`;
    };
  }, [page]);
}

export default usePageTitle;
